import apiClient from '@/services/axios'

export async function get(filters) {
  console.log('API filters:', filters)
  
  const params = new URLSearchParams();
  
  // Add showExpired parameter
  params.append('showExpired', filters.showExpired || false);
  
  // Add type filter if not "All"
  if (filters.type && filters.type !== "All") {
    params.append('type', filters.type);
  }
  
  // Add code search parameter
  if (filters.code && filters.code.trim() !== '') {
    params.append('code', filters.code.trim());
  }
  
  // Add campaign search parameter
  if (filters.campaign && filters.campaign.trim() !== '') {
    params.append('campaign', filters.campaign.trim());
  }
  
  // Add includeSubCodes parameter
  if (filters.includeSubCodes !== undefined) {
    params.append('includeSubCodes', filters.includeSubCodes);
  }

  // Add pagination parameters
  if (filters.page !== undefined) {
    params.append('page', filters.page);
  }
  
  if (filters.pageSize !== undefined) {
    params.append('pageSize', filters.pageSize);
  }

  const query = params.toString() ? '?' + params.toString() : '';
  console.log('API query:', query);

  var response = await apiClient.get('/promoCodes' + query)
  if (response) {
    return response.data
  }

  throw new Error('Unable to get Promo Codes.')
}
